module.exports = __webpack_public_path__ + "2dba389a1065531efdfba6eea7d5cfc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/intuit_2021_chart.png
// module id = 1687
// module chunks = 0